import { render } from "./NavigationView.vue?vue&type=template&id=bb46d472&scoped=true"
import script from "./NavigationView.vue?vue&type=script&lang=js"
export * from "./NavigationView.vue?vue&type=script&lang=js"

import "./NavigationView.vue?vue&type=style&index=0&id=bb46d472&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb46d472"]])

export default __exports__